import React from 'react';
import PropTypes from 'prop-types';

import ExtendedTextPrint from './ExtendedTextPrint';
import ExtendedTextInteraction, { isCodeInteraction } from './ExtendedTextInteraction';
import sessionReader from '../../../../store/readHelpers/SessionReader';

function getUserData(userResponse) {
    if (Array.isArray(userResponse) && userResponse.length > 0) {
        return userResponse[0];
    }
    return '';
}

class ExtendedTextInteractionWrapper extends React.Component {
    static propTypes = {
        context: PropTypes.string.isRequired,
        handleInteractionReady: PropTypes.func.isRequired,
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        services: PropTypes.object,
        userResponse: PropTypes.array.isRequired, // array containing the user answer as the only entry
        viewMedia: PropTypes.string.isRequired,
        correctResponses: PropTypes.array,
        defaultValue: PropTypes.array,
        wordCount: PropTypes.number,
    };

    shouldShowPrintView(context, model, viewMedia) {
        if (isCodeInteraction(model)) {
            return false;
        }

        const showAnnotatableResponses = sessionReader.getParam('showAnnotatableResponses');
        if (showAnnotatableResponses !== undefined) {
            return showAnnotatableResponses;
        }

        if (sessionReader.isContextPreview(context) && !sessionReader.isPrintStylePaperBased()) {
            return false;
        } else if (sessionReader.isViewMediaPrintOrPdf(viewMedia)) {
            return true;
        }

        return false;
    }

    render() {
        const { context, handleInteractionReady, model, userResponse, viewMedia } = this.props;
        if (this.shouldShowPrintView(context, model, viewMedia)) {
            const userData = getUserData(userResponse);
            return (
                <ExtendedTextPrint
                    handleInteractionReady={handleInteractionReady}
                    isHtml={model.format !== 'plain'}
                    userData={userData}
                    prompt={model.prompt}
                    viewMedia={viewMedia}
                    showWordCountOption={model.showWordCount}
                />);
        }

        return <ExtendedTextInteraction {...this.props} />;
    }
}

export default ExtendedTextInteractionWrapper;
